import React, { useState } from 'react';
import './Header.css';
import logo from '../images/logo1.png'
import { Link } from 'react-router-dom'
import hamburger from '../images/hamburger-menu.png'
import fb from '../images/fb.png'
import insta from '../images/insta.png'

import { Slide } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css'

import slide1 from '../images/Slide/slide.jpg'
import slide2 from '../images/Slide/slide1.jpg'
import slide3 from '../images/Slide/slide3.jpg'



const slideImages = [
    slide1,
    slide3,
    slide2
  ];

  const properties = {
    duration: 8000,
    transitionDuration: 500,
    infinite: true,
    arrows: true,
    onChange: (oldIndex, newIndex) => {
      console.log(`slide transition from ${oldIndex} to ${newIndex}`);
    }
  }


const Header = () => {

    const [showMenu, setMenu] = useState(false)

    const toggleMenu = () => setMenu(!showMenu)

    return(
        <div>
            <div className="info">
                <a rel="noreferrer" target="_blank" href="https://www.facebook.com/coob.bih"><img className="fblogo" src={fb} alt="facebook-logo" /></a>
                <a rel="noreferrer" target="_blank" href="https://www.instagram.com/centarzaobrazovanjebijeljina/"><img className="fblogo" src={insta} alt="instagram-logo" /></a>
                <h6 className="infotxt" style={{float:'left'}}>055/423-994</h6>
                <h6 className="infotxt" style={{float:'right',paddingRight: '20px'}}>savicml@hotmail.com</h6>
            </div>
        <div className="header">
        <img onClick={toggleMenu} className="hambmenu" src={hamburger} alt="hamburgermenu" />
            <ul>  
                <Link to="/"><img className="logo" src={logo} alt="" /></Link>
                {/* <li><Link className="nav" to="/kontakt">Kontakt</Link></li>
                <li><Link className="nav" to="/obrazovanje" >Obrazovanje</Link></li>
                <li><Link className="nav" to="/o-nama">O nama</Link></li>
                <li><Link className="nav" to="/osnovni-podaci">Osnovni podaci</Link></li> */}
    <li className="dropdown">
        <Link to="/obrazovanje">Obrazovanje</Link>
          <div className="dropdown-content">
        <Link to="/prekvalifikacija">Prekvalifikacija</Link>
        <Link to="/dokvalifikacija">Dokvalifikacija</Link>
        <Link to="/osposobljavanje">Osposobljavanje</Link>
    </div>
    </li>
    <li className="dropdown">
        <p className="dropbtn">Informacije</p>
        <div className="dropdown-content">
        <Link to="/osnovni-podaci">Osnovni podaci</Link>
        <Link to="/kontakt">Kontakt</Link>
        </div>
    </li>
    <li className="dropdown">
    <p className="dropbtn">Škola</p>
    <div className="dropdown-content">
      <Link to="/o-nama">O školi</Link>
      <Link to="/galerija">Galerija</Link>
    </div>
    </li>

    { showMenu ?
        <div className="mobmenu">
                <Link className="mobmenuitem" to="o-nama">O školi</Link>
                <Link className="mobmenuitem" to="/galerija">Galerija</Link>
                <Link className="mobmenuitem" to="/kontakt">Kontakt</Link>
                <Link className="mobmenuitem" to="/osnovni-podaci">Osnovni podaci</Link>
                <Link className="mobmenuitem" to="/obrazovanje">Obrazovanje</Link>
                <Link className="mobmenuitem" to="/prekvalifikacija">Prekvalifikacija</Link>
                <Link className="mobmenuitem" to="/dokvalifikacija">Dokvalifikacija</Link>
                <Link className="mobmenuitem" to="/osposobljavanje">Osposobljavanje</Link>
        </div>
    :null
    }
    
    </ul> 

        </div>

        <div className="slide-container">
        <Slide {...properties}>
          <div className="each-slide">
            <div style={{'backgroundImage': `url(${slideImages[0]})`}}>
            <span><h1 style={{fontSize:'48px'}}>Centar za obrazovanje odraslih</h1>
                <h3>Ukoliko nemate završenu srednju školu nego imate završene razne kurseve za to, <br />
                koji imaju privremeni karakter i sa kojima nemate pravo otvarati samostalne radnje, <br />
                iskoristite ovu našu ponudu - da dosta brzo i finansijski jeftino završite stepenovanu<br />
                jednu od <Link to="/obrazovanje" className="nask" >navedenih škola</Link>, koja se unosi u radnu knjižicu i sa kojom <br /> 
                ako je četvrtog stepena možete nastaviti dalje školovanje <br /> na državnim ili privatnim fakultetima.</h3></span>
            </div>
          </div>
          <div className="each-slide">
            <div style={{'backgroundImage': `url(${slideImages[1]})`}}>
            <span><h1 style={{fontSize:'48px'}}>Konkurs</h1>
                <Link to="/konkurs" ><h3>Podaci i informacije o konkursu za školsku 2021/2022.</h3></Link>
                <Link to="/konkurs"><h3>Prijava za upis polaznika.</h3></Link></span>
            </div>
          </div>
          <div className="each-slide">
            <div style={{'backgroundImage': `url(${slideImages[2]})`}}>
            <span><h1 style={{fontSize:'48px'}}>Obezbjeđena praksa</h1>
                <h3>Ustanova ,,Centar za obrazovanje odraslih“ pruža <br /> obezbjeđenu praksu za sva <Link to="/obrazovanje" className="nask" >zanimanja</Link>.</h3></span>
            </div>
          </div>
        </Slide>
      </div>


        {/* <div className="fade-in">
            <img className="image" src={image} alt="banner" />
            <img className="image2" src={image2} alt="banner" />
        </div> */}


        </div>
    );
}

export default Header;